import { buildURL } from "@comparaonline/cloudinary-image";
import Grid from "@material-ui/core/Grid";
import { Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const style = ({ spacing }: Theme) => ({
  container: {
    padding: `${spacing.unit * 2}px`
  },
  img: {
    width: "100%"
  }
});

const formSummarySkeleton = buildURL(
  "v1570822224/assets/placeholders/form-delightful/form-summary.svg"
);

export type IProps = WithStyles<typeof style>;

export const LoadingSummaryBase: React.FC<IProps> = ({ classes }) => (
  <Grid className={classes.container} container={true} justify={"center"}>
    <Grid item={true}>
      <img className={classes.img} src={formSummarySkeleton} alt={"form-summary-placeholder"} />
    </Grid>
  </Grid>
);

const LoadingSummary = withStyles(style)(LoadingSummaryBase);

export { LoadingSummary };
